import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get, isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { setNavStep } from '../app-main/actions/nav';
import { VerificationForm } from 'shared-components/flow-signup/verification-form';
import { PageSpinner } from 'shared-components/decorators/spinner';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import SignupSuccessModal from './SignupSuccessModal';
import { FormattedMessage } from 'react-intl';

class SignupVerify extends Component {
  constructor (props) {
    super(props);

    this.state = {
      displayFooter: false,
      displaySuccessModal: false
    };

    this.verificationFooter = this.verificationFooter.bind(this);
  }

  componentDidMount () {
    const { dispatch } = this.props;
    dispatch(setNavStep('Signup', 90));
  }

  verificationFooter () {
    this.setState({ displayFooter: true });
    setTimeout(() => {
      return this.setState({ displayFooter: false });
    }, 3500);
  }


  render () {
    const { profile = {} } = this.props;
    const emailIsVerified = get(profile, 'data.email_verified', false);


    if (!isEmpty(profile)) {
      return (
        <div className="SignupMain flex container center">
          <div className="signup-page-container">
            <div className="text-center">
              <h3>
                <FormattedMessage id='referrals.signup_verify.verify_email' defaultMessage='Verify your email' />
              </h3>
              <p>
                <FormattedMessage id='referrals.signup_verify.check_email' defaultMessage='Please check your email and enter the 4-digit code below.' />
              </p>
            </div>
            <VerificationForm
              verificationFooter={this.verificationFooter}
              callbackFn={() => { this.setState({ displaySuccessModal: true }); }}
            />
            {
              this.state.displayFooter &&
              <p className="subform-text text-center text-valid">
                <i className="ico icon-yes text-green"/>&nbsp;
                <FormattedMessage id='referrals.signup_verify.code_sent' defaultMessage='Code Sent!' />
              </p>
            }
          </div>
          <BootstrapModal
            modalClass="SignupSuccessModal"
            body={<SignupSuccessModal />}
            onClose={ () => { window.location.href = '/'; }}
            modalSize="sm-size"
            footer={<div>&nbsp;</div>}
            showModal={this.state.displaySuccessModal || emailIsVerified}
          />
        </div>
      );
    }

    return <PageSpinner additionalStyle="gray" />;
  }
}

SignupVerify.propTypes = {
  dispatch: PropTypes.func,
  params: PropTypes.object,
  profile: PropTypes.object
};

const mapStateToProps = (state = {}) => {
  const profile = get(state, 'profile');

  return {
    profile
  };
};


export default connect(mapStateToProps)(SignupVerify);
